import {
  CellStyleModule,
  ClientSideRowModelApiModule,
  ClientSideRowModelModule,
  ColumnApiModule,
  EventApiModule,
  Module,
  ModuleRegistry,
  RenderApiModule,
  RowApiModule,
  RowAutoHeightModule,
  RowSelectionModule,
  ValidationModule
} from 'ag-grid-community';

export const agGridModules: Module[] = [
  ClientSideRowModelModule,
  ClientSideRowModelApiModule,
  ValidationModule,
  RowSelectionModule,
  RowAutoHeightModule,
  CellStyleModule,
  ColumnApiModule,
  RenderApiModule,
  EventApiModule,
  RowApiModule
];

export const registerAgGridModules = (): void => {
  ModuleRegistry.registerModules(agGridModules);
};
